import styled from "styled-components";

export const Fieldset = styled.fieldset`
    border: none;
`;

export const Wrapper = styled.div<{
    columns?: number;
}>`
    display: grid;
    gap: 1rem;
    padding: 1rem 0;
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr) `};
`;
